

import __layout_0 from '/home/runner/work/wecarexm-fe/wecarexm-fe/src/layouts/default.vue'
export const layouts = {
'blank': () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/layouts/blank.vue'),
'client': () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/layouts/client.vue'),
'default': __layout_0,
'docs': () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/layouts/docs.vue'),
'components/DefaultLayoutWithHorizontalNav': () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/layouts/components/DefaultLayoutWithHorizontalNav.vue'),
'components/DefaultLayoutWithVerticalNav': () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/layouts/components/DefaultLayoutWithVerticalNav.vue'),
'components/Footer': () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/layouts/components/Footer.vue'),
'components/NavBarNotifications': () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/layouts/components/NavBarNotifications.vue'),
'components/NavSearchBar': () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/layouts/components/NavSearchBar.vue'),
'components/NavbarModules': () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/layouts/components/NavbarModules.vue'),
'components/NavbarShortcuts': () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/layouts/components/NavbarShortcuts.vue'),
'components/NavbarThemeSwitcher': () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/layouts/components/NavbarThemeSwitcher.vue'),
'components/UserProfile': () => import('/home/runner/work/wecarexm-fe/wecarexm-fe/src/layouts/components/UserProfile.vue'),
}

export function setupLayouts(routes) {
  return routes.map(route => {
    return { 
      path: route.path,
      meta: route.meta,
      component: layouts[route.meta?.layout || 'default'],
      children: route.path === '/' ? [route] : [{...route, path: ''}]
    }
  })
}
